/**
 * Utility functions for formatting values in simulation results
 */

export const formatCurrency = (value) => {
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    maximumFractionDigits: 0,
  }).format(value);
};

export const formatCurrencyCompact = (value) => {
  if (Math.abs(value) >= 1000000) {
    return `${(value / 1000000).toFixed(1)}M €`;
  } else if (Math.abs(value) >= 1000) {
    return `${(value / 1000).toFixed(0)}K €`;
  }
  return formatCurrency(value);
};

export const formatPercent = (value) => {
  return new Intl.NumberFormat('fr-FR', {
    style: 'percent',
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  }).format(value);
};

export const formatNumber = (value, decimals = 0) => {
  return new Intl.NumberFormat('fr-FR', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value);
};

export const getStatusConfig = (status) => {
  const statusConfigs = {
    viable: { 
      bg: 'bg-emerald-50 dark:bg-emerald-900/20', 
      border: 'border-emerald-400 dark:border-emerald-600',
      text: 'text-emerald-700 dark:text-emerald-400',
      badge: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/50 dark:text-emerald-400'
    },
    risky: { 
      bg: 'bg-amber-50 dark:bg-amber-900/20', 
      border: 'border-amber-400 dark:border-amber-600',
      text: 'text-amber-700 dark:text-amber-400',
      badge: 'bg-amber-100 text-amber-700 dark:bg-amber-900/50 dark:text-amber-400'
    },
    'non-viable': { 
      bg: 'bg-red-50 dark:bg-red-900/20', 
      border: 'border-red-400 dark:border-red-600',
      text: 'text-red-700 dark:text-red-400',
      badge: 'bg-red-100 text-red-700 dark:bg-red-900/50 dark:text-red-400'
    },
  };
  return statusConfigs[status] || statusConfigs['non-viable'];
};

export const getVerdictConfig = (verdict) => {
  const verdictConfigs = {
    GO: {
      bg: 'bg-emerald-500',
      text: 'text-white',
      label: 'GO',
      description: 'Projet validé'
    },
    A_ETUDE: {
      bg: 'bg-amber-500',
      text: 'text-white',
      label: "À L'ÉTUDE",
      description: 'En commission'
    },
    NO_GO: {
      bg: 'bg-red-500',
      text: 'text-white',
      label: 'NO GO',
      description: 'Projet rejeté'
    }
  };
  return verdictConfigs[verdict] || verdictConfigs['NO_GO'];
};
